import React from 'react';
import FadeIn from './FadeIn';
import FilloutEmbed from './FilloutEmbed';

const Contact = () => {
  return (
    <section id="contact" className="bg-brand-charcoal text-brand-vintage relative overflow-hidden" style={{scrollMarginTop: '120px'}}>
      <div className="absolute top-0 right-0 w-1/2 h-full bg-brand-olive/5 skew-x-12 translate-x-1/4 pointer-events-none" />
      <div className="py-32 md:py-40 px-6 relative z-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-20 lg:gap-32">
          {/* Left — Story Panel */}
          <FadeIn className="flex flex-col justify-center">
            <span className="text-brand-bronze uppercase tracking-[0.4em] text-[10px] font-bold mb-8 block">
              Begin Your Journey
            </span>
            <h2 className="font-serif text-5xl md:text-6xl lg:text-7xl mb-10 font-light leading-[1.05]">
              Start With <br />
              <span className="italic">Your Date</span>
            </h2>
            <p className="font-sans text-brand-vintage/80 mb-8 font-light text-lg leading-relaxed max-w-md tracking-wide">
              We'd love to hear about your vision. Tell us a little about your celebration, and we’ll check our calendar to see how we can bring it to life.
            </p>
            <p className="font-sans text-brand-bronze mb-16 font-light text-sm italic tracking-wide">
              No pressure. Just a conversation about what you're envisioning.
            </p>
            <div className="space-y-12 border-t border-brand-vintage/10 pt-12">
              <div>
                <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-vintage/50 mb-3 font-bold">
                  The Estate
                </h4>
                <p className="font-sans text-brand-vintage/90 font-light tracking-wide text-base">
                  4467 Padua Ave, Claremont, CA 91711
                </p>
              </div>
              <div>
                <h4 className="text-[10px] uppercase tracking-[0.3em] text-brand-vintage/50 mb-3 font-bold">
                  Connect
                </h4>
                <a href="tel:909-624-8628" className="font-sans text-brand-vintage/90 font-light tracking-wide text-base block mb-3 hover:text-brand-olive transition-colors">
                  909-624-8628
                </a>
                <a href="mailto:paduahillstheatre@gmail.com" className="font-sans text-brand-vintage/90 font-light tracking-wide text-base hover:text-brand-olive transition-colors">
                  paduahillstheatre@gmail.com
                </a>
              </div>
            </div>
          </FadeIn>
          {/* Right — Fillout Form Embed */}
          <FadeIn delay={0.2} className="flex flex-col">
            <div className="bg-brand-vintage text-brand-charcoal rounded-sm shadow-2xl overflow-hidden w-full relative h-full min-h-[500px]">
              <FilloutEmbed />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default Contact;